import { BrandOnboardingPage } from "@features/BestiesOnboarding/BrandOnboardingPage";
import { ONBOARDING_STEP_IDS } from "@features/BestiesOnboarding/onboardingSteps";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const searchSchema = z.object({
  step: z.enum(ONBOARDING_STEP_IDS).optional(),
});

export const Route = createFileRoute(
  "/_auth/besties/$siteId/onboarding_/$brandId",
)({
  component: BrandOnboardingPage,
  validateSearch: zodValidator(searchSchema),
});
